import prop from "ramda/src/prop";
import sortBy from "ramda/src/sortBy";

export const sortByOrder = sortBy(prop("order"));
